export default __webpack_public_path__ + "static/media/welcomeHoarding.fea3e57a.png";